/**
 * @typedef {Object} SummaryPluginOptions
 * @property {{String: Function}} options.customValues
 * @property {{String: object}} options.groupItems - Unlike DataGrid default, group items are
 *  aligned by column by default. This can be overriden by setting alignByColumn to `false`
 *  in the item definition.
 * @property {{String: object}} options.totalItems
 */

/**
 * @param {SummaryPluginOptions} options
 *
 * @returns {import("../datagrid").Plugin}
 */
export function summaryPlugin(options) {
  const customValues = options.customValues;
  const groupItems = summaryItems(options.groupItems, customValues).map((item) => ({ alignByColumn: true, ...item }));
  const totalItems = summaryItems(options.totalItems, customValues);

  return {
    options: {
      summary: {
        texts: {
          sum: "{0}",
          count: "{0}",
          avg: "{0}",
        },
        calculateCustomSummary(options) {
          const compute = customValues[options.name];
          compute(options);
        },
        groupItems: groupItems,
        totalItems: totalItems,
      },
    },
  };
}

function summaryItems(itemsMap, customValues) {
  let dataGridItems = [];

  for (const fieldName in itemsMap) {
    if (!Object.hasOwn(itemsMap, fieldName)) {
      continue;
    }

    const attributes = { ...itemsMap[fieldName] };

    attributes.column = fieldName;

    if (attributes.summaryType === "custom") {
      attributes.name = fieldName;

      if (!Object.hasOwn(customValues, fieldName)) {
        throw new Error(`Field "${fieldName}" summaryType is set to "custom", but no custom value was provided`);
      }
    }

    dataGridItems.push(attributes);
  }

  return dataGridItems;
}
